export default __webpack_public_path__ + "media/images/lp/img2-ec14c91af29d33d536baae025f673ddd.png";